import React from "react";
import ReactDOM from "react-dom/client";
import "./css/output.css"; // Import Tailwind CSS
import "./css/global.css"; // Import global CSS (optional)
import "./css/styles.css"; // Import global CSS (optional)
import App from "./App"; // Import the root App component

// Render the App component inside the element with id 'root'
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
